var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 10.9999H7.4135L11.7065 6.70687C12.0965 6.31687 12.0965 5.68388 11.7065 5.29288C11.3165 4.90188 10.6835 4.90288 10.2925 5.29288L4.2925 11.2929C3.9025 11.6829 3.9025 12.3159 4.2925 12.7069L10.2925 18.7069C10.4875 18.9019 10.7425 18.9999 10.9995 18.9999C11.2565 18.9999 11.5115 18.9019 11.7065 18.7069C12.0965 18.3169 12.0965 17.6839 11.7065 17.2929L7.4135 12.9999H19.9995C20.5525 12.9999 20.9995 12.5529 20.9995 11.9999C20.9995 11.4469 20.5525 10.9999 19.9995 10.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiBackButton);
export default __webpack_public_path__ + "static/media/hi-back-button.e8ae0add18b0be2d4d67d9b7687f0b19.svg";
export { ForwardRef as ReactComponent };